// extracted by mini-css-extract-plugin
export default {"focusWithinIndicator":"focusWithinIndicator---AmPo1","withNegativeOffset":"withNegativeOffset---XoQn6","managerHeader":"managerHeader---rB8Rf focusWithinIndicator---AmPo1"};